<div
  [translatable]="{
    transKey: labelTranslationKey,
    modEnum: labelTranslationModuleEnum
  }"
>
  <div class="badge-status" [ngClass]="checkStatusCode(statusCode)">
    {{ statusName | translate }}
  </div>
</div>
